export default __webpack_public_path__ + "static/media/köide_003 copy.11ebd1ef.png";